import React, { Component } from "react";
import Button from "../Button";
import Col from "../Col";
import Form, { Heading } from "../Form";
import Input from "../Input";
import Row from "../Row";
import Select from "../Select";
import Picker from "../Picker";
import { selectItems, selectItemsForAssets } from "../../store/selectors/items";
import { selectAssetFormData } from "../../store/selectors/assetForm";
import {
  setAssetFormData,
  clearAssetFormData,
} from "../../store/actions/assetForm";
import {
  clearValidation,
  fetchPropertyCatalog,
  clearPropertiesCatalog,
} from "../../store/actions/assets";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { selectContacts } from "../../store/selectors/contacts";
import { selectValidation } from "../../store/selectors/Validation";
import Loader from "../Loader";
import { selectFormLoader } from "../../store/selectors/FormLoader";
import moment from "moment";
import Checkbox from "../Checkbox";
import { selectAssets } from "../../store/selectors/assets";

import { variables } from "../../Tenants";
import {
  selectFormOptions,
  selectPropertiesCatalog,
} from "../../store/selectors/formOptions";

class AssetForm extends Component {
  state = {
    formData: {
      item_id: "",
      serial_number: "",
      room: "",
      dateOfPurchase: null,
    },
    buttonPressed: "",
    display: false,
    vendorSearch: "",
    displayItem: false,
    itemSearch: "",
    isChanged: false,
    room: this.props.assetFormData.areaId
      ? this.props.assetFormData.areaId
      : "",
  };
  async componentWillMount() {
    const {
      propertyId,
      assetFormData,
      clearValidation,
      setAssetFormData,
      onFetchPropertyCatalog,
      onClearPropertiesCatalog,
    } = this.props;
    if (!(assetFormData && assetFormData.dateOfPurchase)) {
      setAssetFormData({
        dateOfPurchase: moment(new Date()).format("MM-DD-YYYY"),
      });
    }
    await onClearPropertiesCatalog();
    onFetchPropertyCatalog(propertyId);
    clearValidation();
  }

  componentDidUpdate(prevProps) {
    const {
      setAssetFormData,
      assetFormData,
      validation,
      onClose,
      clearValidation,
      clearAssetFormData,
      assets,
    } = this.props;
    let assetWarrantyDefaultStartDate =
      assetFormData.assetWarrantyDefaultStartDate;
    if (prevProps.assets !== assets) {
      if (this.props.selectedAreaId) {
        if (!assetFormData.areaId) {
          let selectedData = assets.filter(
            (room) => room.areaId === this.props.selectedAreaId
          )[0];

          setAssetFormData({
            roomType:
              selectedData && selectedData.customLabel
                ? selectedData.customLabel
                : selectedData.name,
            areaId: selectedData.areaId,
          });
        }
      }
    }
    if (!(assetFormData && assetFormData.dateOfPurchase)) {
      setAssetFormData({
        dateOfPurchase: moment(new Date()).format("MM-DD-YYYY"),
      });
    }
    if (validation.status === true) {
      if (
        validation.message ===
        "This serial number already exists, please try another."
      ) {
        clearValidation();
      } else if (
        validation.message === "Success" &&
        this.state.buttonPressed === "SaveAndClose"
      ) {
        onClose();
        clearAssetFormData();
        clearValidation();
      } else if (
        validation.message === "Success" &&
        this.state.buttonPressed === "SaveAndAdd"
      ) {
        clearAssetFormData();
        setAssetFormData({
          assetWarrantyDefaultStartDate: assetWarrantyDefaultStartDate,
          dateOfPurchase: assetWarrantyDefaultStartDate,
        });
        clearValidation();
      }
    }
  }

  onChange = (object) => {
    const { assetFormData, setAssetFormData, formOptions } = this.props;
    let data = {};
    let propertiesCatalog = formOptions.propertiesCatalog;
    for (var i = 0; i < propertiesCatalog.length; i++) {
      if (propertiesCatalog[i].id === object.value) {
        data.item = {
          name: propertiesCatalog[i].name,
          make: propertiesCatalog[i].makeName,
          model: propertiesCatalog[i].model,
        };
      }
    }
    data.itemId = object.value;

    setAssetFormData({
      ...assetFormData,
      ...data,
    });
    setAssetFormData({
      itemName: object.label,
    });
    this.setState({ displayItem: false, itemSearch: "", isChanged: false });
  };

  onSaveAsset(fndData) {
    const {  onSaveAsset } = this.props;
    onSaveAsset(fndData);
  }

  handleSelectedValue(e) {
    const { assets, setAssetFormData } = this.props;
    let selectedData = assets.filter(
      (room) => room.areaId === e.target.value
    )[0];
    setAssetFormData({
      roomType:
        selectedData && selectedData.customLabel
          ? selectedData.customLabel
          : selectedData.name,
      areaId: selectedData.areaId,
    });
  }

  render() {
    const {
      assetFormData,
      setAssetFormData,
      onClose,
      loader,
      catalog,
      newAsset,
      contacts,
      assets,
    } = this.props;

    let vendorContacts = contacts.filter((item) =>
      item.roles && item.roles.length > 0
        ? item.roles[0].role.name === "Vendor"
        : []
    );
    let condition;
    if (
      assetFormData &&
      assetFormData.assetWarrantyDefaultStartDate &&
      assetFormData &&
      assetFormData.dateOfPurchase
    ) {
      if (
        moment(assetFormData.assetWarrantyDefaultStartDate).format(
          "MM-DD-YYYY"
        ) === moment(assetFormData.dateOfPurchase).format("MM-DD-YYYY")
      ) {
        condition = true;
      } else {
        condition = false;
      }
    }
    return (
      <Form
        headline={newAsset ? "Add an Asset" : "Edit an Asset"}
        onClose={onClose}
        onSubmit={() => this.onSaveAsset(assetFormData)}
        actions={
          <>
            {loader ? <Loader center={true} /> : null}
            {newAsset ? (
              <Button
                color="semantic"
                size="small"
                label="Save and Add Another"
                onClick={() =>
                  this.setState({
                    buttonPressed: "SaveAndAdd",
                    vendorSearch: "",
                  })
                }
                disabled={
                  (assetFormData.item && assetFormData.item.id
                    ? !assetFormData.item.id
                    : !assetFormData.itemId) ||
                  (assetFormData.allRooms && assetFormData.allRooms === true
                    ? !assetFormData.allRooms
                    : !assetFormData.roomType) ||
                  !assetFormData.dateOfPurchase
                }
              />
            ) : (
              <div />
            )}

            <Button
              color="teal"
              size="small"
              label="Save Asset"
              onClick={() =>
                this.setState({
                  buttonPressed: "SaveAndClose",
                })
              }
              disabled={
                (assetFormData.item && assetFormData.item.id
                  ? !assetFormData.item.id
                  : !assetFormData.itemId) ||
                (assetFormData.allRooms && assetFormData.allRooms === true
                  ? !assetFormData.allRooms
                  : !assetFormData.roomType)
              }
            />
          </>
        }
        component={
          <>
            <Row mdCenter>
              <Col xs="12" md="6">
                <Heading>Asset Details</Heading>
                <Input
                  value={
                    this.state.isChanged
                      ? assetFormData.itemName
                      : assetFormData.item && assetFormData.item.id
                      ? assetFormData.item.name
                      : assetFormData.itemId
                      ? assetFormData.itemName
                      : assetFormData.itemName
                  }
                  onChange={(e) => {
                    setAssetFormData({ itemName: e.target.value });
                    this.setState({
                      displayItem: true,
                      isChanged: true,
                      itemSearch: e.target.value,
                    });
                  }}
                  label="Item"
                  placeholder="Start typing the Item's name to choose one"
                  block
                />
                <Col>
                  {this.state.itemSearch
                    ? catalog
                        .filter(
                          ({ label }) =>
                            label
                              .toLowerCase()
                              .indexOf(this.state.itemSearch.toLowerCase()) > -1
                        )
                        .map((value, i) => {
                          return (
                            <div
                              onClick={() => this.onChange(value)}
                              className="input__autoComplete"
                              key={i}
                            >
                              <span>{value.label}</span>
                            </div>
                          );
                        })
                    : null}
                </Col>
                <Select
                  value={assetFormData.areaId ? assetFormData.areaId : ""}
                  onChange={(e) => this.handleSelectedValue(e)}
                  options={assets.map((assetRoom) => ({
                    value: assetRoom.areaId,
                    label:
                      assetRoom && assetRoom.customLabel
                        ? assetRoom.customLabel
                        : assetRoom.name,
                  }))}
                  label={variables.roomName}
                  placeholder={"(Select " + variables.roomName + ")"}
                  block
                  disabled={assetFormData.allRooms === true}
                />
                {assetFormData.id ? null : (
                  <Checkbox
                    label={"All " + variables.roomName + "s"}
                    value={assetFormData.allRooms}
                    onChange={() =>
                      setAssetFormData({
                        allRooms:
                          assetFormData.allRooms &&
                          assetFormData.allRooms === true
                            ? false
                            : true,
                      })
                    }
                  />
                )}
                {condition ? (
                  <div
                    style={{
                      alignItems: "flex-start",
                      display: "flex",
                      marginBottom: 10,
                      color: "#D3D3D3",
                    }}
                  >
                    {`Default date is set at the ${variables.suite} level`}.
                  </div>
                ) : null}
                <Picker
                  label="Warranty Commencement Date"
                  placeholderText="Choose Date"
                  required={false}
                  showPopperArrow={false}
                  selected={
                    assetFormData && assetFormData.dateOfPurchase
                      ? new Date(
                          moment
                            .utc(assetFormData.dateOfPurchase)
                            .format("l LT")
                        )
                      : null
                  }
                  onChange={(date) =>
                    setAssetFormData({ dateOfPurchase: date })
                  }
                />
                <Input
                  value={
                    assetFormData.vendorName
                      ? assetFormData.vendorName
                      : this.state.vendorSearch
                  }
                  onChange={(e) => {
                    setAssetFormData({
                      vendorName: e.target.value,
                      vendorId: null,
                    });
                    this.setState({
                      display: true,
                      vendorSearch: e.target.value,
                    });
                  }}
                  label="Vendor"
                  placeholder="Start typing the Vendor's name to choose one"
                  block
                />
                <Col>
                  {this.state.vendorSearch
                    ? vendorContacts
                        .filter(
                          ({ firstname, lastname }) =>
                            firstname
                              .toLowerCase()
                              .indexOf(this.state.vendorSearch.toLowerCase()) >
                              -1 ||
                            lastname
                              .toLowerCase()
                              .indexOf(this.state.vendorSearch.toLowerCase()) >
                              -1
                        )
                        .map((value, i) => {
                          return (
                            <div
                              onClick={() => {
                                setAssetFormData({
                                  vendorId: value.id,
                                  vendorName:
                                    value.firstname + " " + value.lastname,
                                });
                                this.setState({
                                  display: false,
                                  vendorSearch: "",
                                });
                              }}
                              className="input__autoComplete"
                              key={i}
                            >
                              <span>
                                {value.firstname + " " + value.lastname}
                              </span>
                            </div>
                          );
                        })
                    : null}
                </Col>
              </Col>
            </Row>
          </>
        }
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  items: selectItems(state),
  itemDropDown: selectItemsForAssets(state),
  assetFormData: selectAssetFormData(state),
  assets: selectAssets(state),
  contacts: selectContacts(state),
  validation: selectValidation(state),
  loader: selectFormLoader(state),
  formOptions: selectFormOptions(state),
  catalog: selectPropertiesCatalog(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setAssetFormData,
      clearAssetFormData,
      clearValidation: clearValidation,
      onFetchPropertyCatalog: fetchPropertyCatalog,
      onClearPropertiesCatalog: clearPropertiesCatalog,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AssetForm);
